module.exports = __webpack_public_path__ + "static/media/AF.85b342ae.png";